import initialState from "../initialState";

import {
  FILTERS_ARE_LOADED,
  FILTERS_ARE_LOADING,
  FILTERS_LOADED_WITH_ERROR,
  FILTERS_TYPES_ARE_LOADED,
  FILTERS_TYPES_ARE_LOADING,
  FILTERS_TYPES_LOADED_WITH_ERROR,
  FILTER_SUCCESS_MESSAGE_RAISED,
  FILTER_FAILURE_MESSAGE_RAISED,
  FILTER_MESSAGES_RESTARTED,
  SET_CURRENT_FILTER,
  REGULATORY_STREAM_ARE_LOADED,
  REGULATORY_STREAM_ARE_LOADING,
  REGULATORY_STREAM_LOADED_WITH_ERROR,
  TOP_5_PUBLISHERS_ARE_LOADING,
  TOP_5_PUBLISHERS_LOADED_WITH_ERROR,
  TOP_5_PUBLISHERS_ARE_LOADED,
  TOP_5_COUNTRIES_ARE_LOADED,
  TOP_5_COUNTRIES_ARE_LOADING,
  TOP_5_COUNTRIES_LOADED_WITH_ERROR,
  GRAPH_AGGREGATION_ARE_LOADED,
  GRAPH_AGGREGATION_ARE_LOADING,
  GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADED,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADING,
  GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING,
  HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR,
  GET_DOCUMENT_IS_LOADED,
  GET_DOCUMENT_IS_LOADING,
  GET_DOCUMENT_IS_LOADED_WITH_ERROR,
  GET_SIMILAR_DOCUMENT_IS_LOADED,
  GET_SIMILAR_DOCUMENT_IS_LOADING,
  GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR,
  DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM,
  ADD_NEWS_ITEM,
  EDIT_NEWS_ITEM,
  REGULATORY_STREAM_ARE_CLEAN,
} from "../actions/actionTypes";

export default function filterReducer(
  state = initialState.filterReducerState,
  action
) {
  switch (action.type) {
    case FILTERS_ARE_LOADED: {
      return {
        ...state,
        filtersAreLoading: false,
        filtersAreLoadedWithError: false,
        filters: action.filters,
      };
    }

    case FILTERS_LOADED_WITH_ERROR: {
      return {
        ...state,
        filtersAreLoading: false,
        filtersAreLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case FILTERS_ARE_LOADING: {
      return {
        ...state,
        filtersAreLoading: true,
        filters: [],
        filtersAreLoadedWithError: "",
      };
    }

    case FILTERS_TYPES_ARE_LOADED: {
      return {
        ...state,
        filtersTypesAreLoading: false,
        filtersTypesAreLoadedWithError: false,
        filtersTypes: action.filtersTypes,
      };
    }

    case FILTERS_TYPES_LOADED_WITH_ERROR: {
      return {
        ...state,
        filtersTypesAreLoading: false,
        filtersTypesAreLoadedWithError: true,
        filtersTypesFailureMessage: action.filterFailureMessage,
      };
    }

    case FILTERS_TYPES_ARE_LOADING: {
      return {
        ...state,
        filtersTypesAreLoading: true,
        filtersTypes: [],
        filtersTypesAreLoadedWithError: "",
      };
    }

    case FILTER_SUCCESS_MESSAGE_RAISED: {
      return {
        ...state,
        filterSuccessMessage: action.filterSuccessMessage,
      };
    }

    case FILTER_FAILURE_MESSAGE_RAISED: {
      return {
        ...state,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case FILTER_MESSAGES_RESTARTED: {
      return {
        ...state,
        filterFailureMessage: "",
        filterSuccessMessage: "",
      };
    }

    case SET_CURRENT_FILTER: {
      return {
        ...state,
        currentFilter: action.currentFilter,
      };
    }

    case REGULATORY_STREAM_ARE_LOADED: {
      return {
        ...state,
        regulatoryStream: [
          ...state.regulatoryStream,
          ...action.regulatoryStream,
        ],
        regulatoryStreamAreLoading: false,
        regulatoryStreamLoadedWithError: false,
        regulatoryStreamPaginationError: false,
      };
    }

    case REGULATORY_STREAM_ARE_CLEAN: {
      return {
        ...state,
        regulatoryStream: [],
        regulatoryStreamAreLoading: false,
        regulatoryStreamLoadedWithError: false,
        regulatoryStreamPaginationError: false,
      };
    }

    case REGULATORY_STREAM_ARE_LOADING: {
      if (!action.page)
        return {
          ...state,
          regulatoryStream: [],
          regulatoryStreamAreLoading: true,
          regulatoryStreamLoadedWithError: false,
          regulatoryStreamPaginationError: false,
        };

      return {
        ...state,
        regulatoryStreamAreLoading: true,
        regulatoryStreamLoadedWithError: false,
        regulatoryStreamPaginationError: false,
      };
    }

    case REGULATORY_STREAM_LOADED_WITH_ERROR: {
      return {
        ...state,
        regulatoryStreamAreLoading: false,
        regulatoryStreamLoadedWithError: action.payload.page ? false : true,
        regulatoryStreamPaginationError: action.payload.page ? true : false,
        filterFailureMessage: action.payload.page
          ? ""
          : action.payload.filterFailureMessage,
      };
    }

    case DELETE_NEWS_BY_ID_FROM_REGULATORY_STREAM: {
      return {
        ...state,
        regulatoryStream: [
          ...(state.regulatoryStream || []).filter(
            (item) => item?.id !== action.newsId
          ),
        ],
      };
    }

    case ADD_NEWS_ITEM: {
      return {
        ...state,
        regulatoryStream: [...(state.regulatoryStream || []), action.news],
      };
    }

    case EDIT_NEWS_ITEM: {
      return {
        ...state,
        regulatoryStream: [
          ...(state.regulatoryStream || []).map((item) => {
            if (item.id === action.news.id) {
              return {
                ...item,
                ...action.news,
              };
            }
            return item;
          }),
        ],
      };
    }

    case TOP_5_PUBLISHERS_ARE_LOADED: {
      return {
        ...state,
        top5Publishers: action.top5Publishers,
        top5PublishersAreLoading: false,
        top5PublishersLoadedWithError: false,
      };
    }

    case TOP_5_PUBLISHERS_ARE_LOADING: {
      return {
        ...state,
        top5Publishers: {},
        top5PublishersAreLoading: true,
        top5PublishersLoadedWithError: false,
      };
    }

    case TOP_5_PUBLISHERS_LOADED_WITH_ERROR: {
      return {
        ...state,
        top5Publishers: {},
        top5PublishersAreLoading: false,
        top5PublishersLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
        graphAggregationsTotalAmount: 0,
      };
    }

    case TOP_5_COUNTRIES_ARE_LOADED: {
      return {
        ...state,
        top5Countries: action.top5Countries,
        top5CountriesAreLoading: false,
        top5CountriesLoadedWithError: false,
      };
    }

    case TOP_5_COUNTRIES_ARE_LOADING: {
      return {
        ...state,
        top5Countries: {},
        top5CountriesAreLoading: true,
        top5CountriesLoadedWithError: false,
      };
    }

    case TOP_5_COUNTRIES_LOADED_WITH_ERROR: {
      return {
        ...state,
        top5Countries: {},
        top5CountriesAreLoading: false,
        top5CountriesLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
        graphAggregationsTotalAmount: 0,
      };
    }

    case HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED: {
      return {
        ...state,
        hotTopics: action.hotTopicsAndBusinessUnits?.Topics || {},
        hotBusinessUnits:
          action.hotTopicsAndBusinessUnits["Business Units"] || {},
        hotTopicsAndBusinessUnitsAreLoading: false,
        hotTopicsAndBusinessUnitsLoadedWithError: false,
      };
    }

    case HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADING: {
      return {
        ...state,
        hotTopics: {},
        hotBusinessUnits: {},
        hotTopicsAndBusinessUnitsAreLoading: true,
        hotTopicsAndBusinessUnitsLoadedWithError: false,
      };
    }

    case HOT_TOPICS_AND_BUSINESS_UNITS_ARE_LOADED_WITH_ERROR: {
      return {
        ...state,
        hotTopics: {},
        hotBusinessUnits: {},
        hotTopicsAndBusinessUnitsAreLoading: false,
        hotTopicsAndBusinessUnitsLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case GRAPH_AGGREGATION_ARE_LOADED: {
      return {
        ...state,
        graphAggregations: action.graphAggregations,
        graphAggregationsAreLoading: false,
        graphAggregationsLoadedWithError: false,
        graphAggregationsTotalAmount: action.graphAggregationsTotalAmount,
      };
    }

    case GRAPH_AGGREGATION_ARE_LOADING: {
      return {
        ...state,
        graphAggregations: [],
        graphAggregationsAreLoading: true,
        graphAggregationsLoadedWithError: false,
        graphAggregationsTotalAmount: 0,
      };
    }

    case GRAPH_AGGREGATION_ARE_LOADED_WITH_ERROR: {
      return {
        ...state,
        graphAggregations: [],
        graphAggregationsAreLoading: false,
        graphAggregationsLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case GRAPH_AGGREGATION_DETAILS_ARE_LOADED: {
      return {
        ...state,
        graphAggregationsDetails: action.graphAggregationsDetails,
        graphAggregationsDetailsAreLoading: false,
        graphAggregationsDetailsLoadedWithError: false,
      };
    }

    case GRAPH_AGGREGATION_DETAILS_ARE_LOADING: {
      return {
        ...state,
        graphAggregationsDetails: [],
        graphAggregationsDetailsAreLoading: true,
        graphAggregationsDetailsLoadedWithError: false,
      };
    }

    case GRAPH_AGGREGATION_DETAILS_ARE_LOADED_WITH_ERROR: {
      return {
        ...state,
        graphAggregationsDetails: [],
        graphAggregationsDetailsAreLoading: false,
        graphAggregationsDetailsLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case GET_DOCUMENT_IS_LOADED: {
      return {
        ...state,
        singleDocument: action.singleDocument,
        singleDocumentIsLoading: false,
        singleDocumentIsLoadedWithError: false,
      };
    }

    case GET_DOCUMENT_IS_LOADING: {
      return {
        ...state,
        singleDocument: {},
        singleDocumentIsLoading: true,
        singleDocumentIsLoadedWithError: false,
      };
    }

    case GET_DOCUMENT_IS_LOADED_WITH_ERROR: {
      return {
        ...state,
        singleDocument: {},
        singleDocumentIsLoading: false,
        singleDocumentIsLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    case GET_SIMILAR_DOCUMENT_IS_LOADED: {
      return {
        ...state,
        singleSimilarDocument: action.singleSimilarDocument,
        singleSimilarDocumenIsLoading: false,
        singleSimilarDocumenIsLoadedWithError: false,
      };
    }

    case GET_SIMILAR_DOCUMENT_IS_LOADING: {
      return {
        ...state,
        singleSimilarDocument: [],
        singleSimilarDocumenIsLoading: true,
        singleSimilarDocumenIsLoadedWithError: false,
      };
    }

    case GET_SIMILAR_DOCUMENT_IS_LOADED_WITH_ERROR: {
      return {
        ...state,
        singleSimilarDocument: [],
        singleSimilarDocumenIsLoading: false,
        singleSimilarDocumenIsLoadedWithError: true,
        filterFailureMessage: action.filterFailureMessage,
      };
    }

    default: {
      return state;
    }
  }
}
